module.exports = __webpack_public_path__ + "assets/img/1.40f378a6.png";